import GroupSelector from './GroupSelector';

export default GroupSelector;
